export const closeSymbol = Symbol("closeModal");
export const instanceSymbol = Symbol("setInstanceSymbol");
